import { render, staticRenderFns } from "./boxDetail.vue?vue&type=template&id=7d658e71&scoped=true"
import script from "./boxDetail.vue?vue&type=script&lang=js"
export * from "./boxDetail.vue?vue&type=script&lang=js"
import style0 from "./boxDetail.vue?vue&type=style&index=0&id=7d658e71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d658e71",
  null
  
)

export default component.exports